module.exports = __webpack_public_path__ + "static/media/Zekrom_gaussian2.dd284a52.png";